module.exports = __webpack_public_path__ + "media/agent_2_patsun.12a5eb59.mp3";